export class RecorderFingerings {
	public static baroqueFingerings:Array<Array<number>> = [
		[0,  0, 0, 0,  0, 0, 0, 0], //C (low)
		[0,  0, 0, 0,  0, 0, 0, 1], //C#
		[0,  0, 0, 0,  0, 0, 0, 2], //D
		[0,  0, 0, 0,  0, 0, 1, 2], //Eb
		[0,  0, 0, 0,  0, 0, 2, 2], //E
		[0,  0, 0, 0,  0, 2, 0, 0], //F
		[0,  0, 0, 0,  2, 0, 0, 2], //F#
		[0,  0, 0, 0,  2, 2, 2, 2], //G
		[0,  0, 0, 2,  0, 0, 1, 2], //Ab
		[0,  0, 0, 2,  2, 2, 2, 2], //A
		[0,  0, 2, 0,  0, 2, 2, 2], //Bb
		[0,  0, 2, 2,  2, 2, 2, 2], //B
		[0,  2, 0, 2,  2, 2, 2, 2], //C
		[2,  0, 0, 2,  2, 2, 2, 2], //C#
		[2,  2, 0, 2,  2, 2, 2, 2], //D
		[2,  2, 0, 0,  0, 0, 0, 2], //Eb
		[1,  0, 0, 0,  0, 0, 2, 2], //E
		[1,  0, 0, 0,  0, 2, 0, 2], //F
		[1,  0, 0, 0,  2, 0, 2, 2], //F#
		[1,  0, 0, 0,  2, 2, 2, 2], //G
		[1,  0, 0, 2,  0, 2, 2, 2], //Ab
		[1,  0, 0, 2,  2, 2, 2, 2], //A
		[1,  0, 0, 2,  0, 0, 0, 2], //Bb
		[1,  0, 0, 2,  0, 0, 2, 2], //B
		[1,  0, 2, 2,  0, 0, 2, 2], //C
		[1,  0, 1, 0,  0, 1, 0, 0], //C#
		[1,  0, 2, 0,  0, 2, 0, 2], //D
		[1,  2, 0, 0,  2, 0, 0, 2]]; //Eb
	
	public static germanFingerings:Array<Array<number>> = [
		[0,  0, 0, 0,  0, 0, 0, 0], //C (low)
		[0,  0, 0, 0,  0, 0, 0, 1], //C#
		[0,  0, 0, 0,  0, 0, 0, 2], //D
		[0,  0, 0, 0,  0, 0, 1, 2], //Eb
		[0,  0, 0, 0,  0, 0, 2, 2], //E
		[0,  0, 0, 0,  0, 2, 2, 2], //F
		[0,  0, 0, 0,  2, 0, 0, 0], //F#
		[0,  0, 0, 0,  2, 2, 2, 2], //G
		[0,  0, 0, 2,  0, 0, 1, 2], //Ab
		[0,  0, 0, 2,  2, 2, 2, 2], //A
		[0,  0, 2, 0,  0, 2, 2, 2], //Bb
		[0,  0, 2, 2,  2, 2, 2, 2], //B
		[0,  2, 0, 2,  2, 2, 2, 2], //C
		[2,  0, 0, 2,  2, 2, 2, 2], //C#
		[2,  2, 0, 2,  2, 2, 2, 2], //D
		[2,  2, 0, 0,  0, 0, 0, 2], //Eb
		[1,  0, 0, 0,  0, 0, 2, 2], //E
		[1,  0, 0, 0,  0, 2, 2, 2], //F
		[1,  0, 0, 0,  2, 0, 2, 0], //F#
		[1,  0, 0, 0,  2, 2, 2, 2], //G
		[1,  0, 0, 0,  2, 0, 0, 0], //Ab
		[1,  0, 0, 2,  2, 2, 2, 2], //A
		[1,  0, 0, 2,  0, 0, 0, 2], //Bb
		[1,  0, 0, 2,  0, 0, 2, 2], //B
		[1,  0, 2, 2,  0, 0, 2, 2], //C
		[1,  0, 2, 0,  0, 2, 0, 0], //C#
		[1,  0, 2, 0,  0, 2, 0, 2], //D
		[1,  2, 0, 0,  2, 0, 0, 2]]; //Eb
	
	public static altoUntransposedFingerings:Array<Array<number>> = [
		[0,  0, 0, 0,  0, 0, 0, 0], //C (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //C# (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //D (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //Eb (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //E (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //F (low)
		[0,  0, 0, 0,  0, 0, 0, 1], //F#
		[0,  0, 0, 0,  0, 0, 0, 2], //G
		[0,  0, 0, 0,  0, 0, 1, 2], //Ab
		[0,  0, 0, 0,  0, 0, 2, 2], //A
		[0,  0, 0, 0,  0, 2, 0, 0], //Bb
		[0,  0, 0, 0,  2, 0, 0, 2], //B
		[0,  0, 0, 0,  2, 2, 2, 2], //C
		[0,  0, 0, 2,  0, 0, 0, 2], //C#
		[0,  0, 0, 2,  2, 2, 2, 2], //D
		[0,  0, 2, 0,  0, 2, 2, 2], //Eb
		[0,  0, 2, 2,  2, 2, 2, 2], //E
		[0,  2, 0, 2,  2, 2, 2, 2], //F
		[2,  0, 0, 2,  2, 2, 2, 2], //F#
		[2,  2, 0, 2,  2, 2, 2, 2], //G
		[2,  2, 0, 0,  0, 0, 0, 2], //Ab
		[1,  0, 0, 0,  0, 0, 2, 2], //A
		[1,  0, 0, 0,  0, 2, 0, 2], //Bb
		[1,  0, 0, 0,  2, 0, 2, 2], //B
		[1,  0, 0, 0,  2, 2, 2, 2], //C
		[1,  0, 0, 2,  0, 2, 2, 2], //C#
		[1,  0, 0, 2,  2, 2, 2, 2], //D
		[1,  0, 0, 2,  0, 0, 0, 2], //Eb
		[1,  0, 0, 2,  0, 0, 2, 2], //E
		[1,  0, 2, 2,  0, 0, 2, 2], //F
		[1,  0, 1, 0,  0, 1, 0, 0], //F#
		[1,  0, 2, 0,  0, 2, 0, 2], //G
		[1,  2, 0, 0,  2, 0, 0, 2]]; //Ab
		
	public static altoUntransposedGermanFingerings:Array<Array<number>> = [
		[0,  0, 0, 0,  0, 0, 0, 0], //C (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //C# (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //D (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //Eb (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //E (not real - place holder)
		[0,  0, 0, 0,  0, 0, 0, 0], //F (low)
		[0,  0, 0, 0,  0, 0, 0, 1], //F#
		[0,  0, 0, 0,  0, 0, 0, 2], //G
		[0,  0, 0, 0,  0, 0, 1, 2], //Ab
		[0,  0, 0, 0,  0, 0, 2, 2], //A
		[0,  0, 0, 0,  0, 2, 2, 2], //Bb
		[0,  0, 0, 0,  2, 0, 0, 0], //B
		[0,  0, 0, 0,  2, 2, 2, 2], //C
		[0,  0, 0, 2,  0, 0, 1, 2], //Db
		[0,  0, 0, 2,  2, 2, 2, 2], //D
		[0,  0, 2, 0,  0, 2, 2, 2], //Eb
		[0,  0, 2, 2,  2, 2, 2, 2], //E
		[0,  2, 0, 2,  2, 2, 2, 2], //F
		[2,  0, 0, 2,  2, 2, 2, 2], //F#
		[2,  2, 0, 2,  2, 2, 2, 2], //G
		[2,  2, 0, 0,  0, 0, 0, 2], //Ab
		[1,  0, 0, 0,  0, 0, 2, 2], //A
		[1,  0, 0, 0,  0, 2, 2, 2], //Bb
		[1,  0, 0, 0,  2, 0, 2, 0], //B
		[1,  0, 0, 0,  2, 2, 2, 2], //C
		[1,  0, 0, 0,  2, 0, 0, 0], //Db
		[1,  0, 0, 2,  2, 2, 2, 2], //D
		[1,  0, 0, 2,  0, 0, 0, 2], //Eb
		[1,  0, 0, 2,  0, 0, 2, 2], //E
		[1,  0, 2, 2,  0, 0, 2, 2], //F
		[1,  0, 2, 0,  0, 2, 0, 0], //F#
		[1,  0, 2, 0,  0, 2, 0, 2], //G
		[1,  2, 0, 0,  2, 0, 0, 2]]; //Ab
}